module.exports = __webpack_public_path__ + "static/media/ProfessionalContent.066feb26.svg";